import React, { useState, useContext } from "react";

import SectionCard from "../../../profiles/SectionCard";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import ConfirmModal from "../../../confirm_modal";
import PrRepresentativeList from "../../reusable/pr_representative_list";
import useRepresentationApi from "../../data/use_representation_api";
import { ProductContext } from "../../data/product_context_management";

// The rail's "Represented by" card, and the owner of all representation state: the add/remove API,
// the pending-removal confirmation, and the list mount (whose hydration outcome it reports back to
// the provider, which owns whether this card is worth showing). Add and remove are awaited — the form and
// the confirmation close only once the write landed and the page refetched, so a failed write
// leaves the affordance open with its error visible instead of silently discarding the attempt.
function RepresentedByCard() {
  const context = useContext(ProductContext);
  const { product, viewerContext, representatives, generalError, setGeneralError, setRepresentativesHydration } =
    context;
  const editable = !!viewerContext?.editable;

  const [representationToDelete, setRepresentationToDelete] = useState(null);
  const [deletingRepresentative, setDeletingRepresentative] = useState(false);
  const { addRepresentation, deleteRepresentation } = useRepresentationApi({ ...context });

  const confirmDelete = async () => {
    setDeletingRepresentative(true);
    const removed = await deleteRepresentation(representationToDelete.id);
    setDeletingRepresentative(false);
    if (removed) setRepresentationToDelete(null);
  };

  const errorAlert = <ServerErrorAlert generalError={generalError} />;

  return (
    <SectionCard id="product-rail-represented-by" title="Represented by">
      {/* While the confirmation is up it carries the alert itself — a failed removal has to be
          readable without dismissing the modal that reports it. */}
      {!representationToDelete && errorAlert}

      <PrRepresentativeList
        representatives={representatives}
        isEditable={editable}
        onAdd={(profileId) => addRepresentation({ promoterProfileId: profileId, promoEntityId: product.id })}
        onRemove={(representation) => {
          setGeneralError(null);
          setRepresentationToDelete(representation);
        }}
        onHydration={setRepresentativesHydration}
      />

      {representationToDelete && (
        <ConfirmModal
          confirmYesText="Remove"
          confirmNoText="Cancel"
          confirmContent={
            <>
              {/* A stub removal carries only a representation_id (no hydrated profile, so no name);
                  fall back to cause-neutral copy rather than "Remove  as a representative?". */}
              <div>
                {representationToDelete.name
                  ? `Remove ${representationToDelete.name} as a representative?`
                  : "Remove this representative?"}
              </div>
              {errorAlert}
            </>
          }
          confirmYes={confirmDelete}
          confirmNo={() => setRepresentationToDelete(null)}
          isOpening
          className="modal-sm p-3"
          confirmNoButtonClassName="shadow-none"
          isSubmitting={deletingRepresentative}
        />
      )}
    </SectionCard>
  );
}

export default RepresentedByCard;
